/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Mitarbeiter API
 * Employee master data: contact details, organisation, keys, parking and vehicles.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EmployeeParking,
  ParkingSpot,
  ParkingSpotInput
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getParkingOverviewUrl = () => {




  return `/api/parking`
}

/**
 * @summary Vehicles and parking spots of every current employee (not of people who left; hidden employees only for
admins), for other apps such as parkapp. Needs the vehicles role (or admin). Read-only.
 */
export const parkingOverview = async ( options?: Parameters<typeof customFetch>[1]): Promise<EmployeeParking[]> => {

  return customFetch<EmployeeParking[]>(getParkingOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getParkingOverviewQueryKey = () => {
    return [
    `/api/parking`
    ] as const;
    }


export const getParkingOverviewQueryOptions = <TData = Awaited<ReturnType<typeof parkingOverview>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParkingOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof parkingOverview>>> = ({ signal }) => parkingOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParkingOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof parkingOverview>>>
export type ParkingOverviewQueryError = unknown


export function useParkingOverview<TData = Awaited<ReturnType<typeof parkingOverview>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parkingOverview>>,
          TError,
          Awaited<ReturnType<typeof parkingOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParkingOverview<TData = Awaited<ReturnType<typeof parkingOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parkingOverview>>,
          TError,
          Awaited<ReturnType<typeof parkingOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParkingOverview<TData = Awaited<ReturnType<typeof parkingOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Vehicles and parking spots of every current employee (not of people who left; hidden employees only for
admins), for other apps such as parkapp. Needs the vehicles role (or admin). Read-only.
 */

export function useParkingOverview<TData = Awaited<ReturnType<typeof parkingOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parkingOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParkingOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListParkingSpotsUrl = () => {




  return `/api/parking-spots`
}

export const listParkingSpots = async ( options?: Parameters<typeof customFetch>[1]): Promise<ParkingSpot[]> => {

  return customFetch<ParkingSpot[]>(getListParkingSpotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListParkingSpotsQueryKey = () => {
    return [
    `/api/parking-spots`
    ] as const;
    }


export const getListParkingSpotsQueryOptions = <TData = Awaited<ReturnType<typeof listParkingSpots>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListParkingSpotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listParkingSpots>>> = ({ signal }) => listParkingSpots({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListParkingSpotsQueryResult = NonNullable<Awaited<ReturnType<typeof listParkingSpots>>>
export type ListParkingSpotsQueryError = unknown


export function useListParkingSpots<TData = Awaited<ReturnType<typeof listParkingSpots>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listParkingSpots>>,
          TError,
          Awaited<ReturnType<typeof listParkingSpots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListParkingSpots<TData = Awaited<ReturnType<typeof listParkingSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listParkingSpots>>,
          TError,
          Awaited<ReturnType<typeof listParkingSpots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListParkingSpots<TData = Awaited<ReturnType<typeof listParkingSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListParkingSpots<TData = Awaited<ReturnType<typeof listParkingSpots>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listParkingSpots>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListParkingSpotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateParkingSpotUrl = () => {




  return `/api/parking-spots`
}

export const createParkingSpot = async (parkingSpotInput: ParkingSpotInput, options?: Parameters<typeof customFetch>[1]): Promise<ParkingSpot> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ParkingSpot>(getCreateParkingSpotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(parkingSpotInput)
  }
);}





export const getCreateParkingSpotMutationKey = () => ['createParkingSpot'] as const;

export const getCreateParkingSpotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createParkingSpot>>, TError,CreateParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createParkingSpot>>, TError,CreateParkingSpotMutationVariables, TContext> => {

const mutationKey = getCreateParkingSpotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createParkingSpot>>, CreateParkingSpotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createParkingSpot(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateParkingSpotMutationResult = NonNullable<Awaited<ReturnType<typeof createParkingSpot>>>
    export type CreateParkingSpotMutationBody = ParkingSpotInput
    export type CreateParkingSpotMutationError = unknown
    export type CreateParkingSpotMutationVariables = {data: ParkingSpotInput}

    export const useCreateParkingSpot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createParkingSpot>>, TError,CreateParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createParkingSpot>>,
        TError,
        CreateParkingSpotMutationVariables,
        TContext
      > => {
      return useMutation(getCreateParkingSpotMutationOptions(options), queryClient);
    }
    export const getUpdateParkingSpotUrl = (id: number,) => {




  return `/api/parking-spots/${id}`
}

export const updateParkingSpot = async (id: number,
    parkingSpotInput: ParkingSpotInput, options?: Parameters<typeof customFetch>[1]): Promise<ParkingSpot> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ParkingSpot>(getUpdateParkingSpotUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(parkingSpotInput)
  }
);}





export const getUpdateParkingSpotMutationKey = () => ['updateParkingSpot'] as const;

export const getUpdateParkingSpotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateParkingSpot>>, TError,UpdateParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateParkingSpot>>, TError,UpdateParkingSpotMutationVariables, TContext> => {

const mutationKey = getUpdateParkingSpotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateParkingSpot>>, UpdateParkingSpotMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateParkingSpot(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateParkingSpotMutationResult = NonNullable<Awaited<ReturnType<typeof updateParkingSpot>>>
    export type UpdateParkingSpotMutationBody = ParkingSpotInput
    export type UpdateParkingSpotMutationError = unknown
    export type UpdateParkingSpotMutationVariables = {id: number;data: ParkingSpotInput}

    export const useUpdateParkingSpot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateParkingSpot>>, TError,UpdateParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateParkingSpot>>,
        TError,
        UpdateParkingSpotMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateParkingSpotMutationOptions(options), queryClient);
    }
    export const getDeleteParkingSpotUrl = (id: number,) => {




  return `/api/parking-spots/${id}`
}

export const deleteParkingSpot = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteParkingSpotUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteParkingSpotMutationKey = () => ['deleteParkingSpot'] as const;

export const getDeleteParkingSpotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteParkingSpot>>, TError,DeleteParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteParkingSpot>>, TError,DeleteParkingSpotMutationVariables, TContext> => {

const mutationKey = getDeleteParkingSpotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteParkingSpot>>, DeleteParkingSpotMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteParkingSpot(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteParkingSpotMutationResult = NonNullable<Awaited<ReturnType<typeof deleteParkingSpot>>>

    export type DeleteParkingSpotMutationError = unknown
    export type DeleteParkingSpotMutationVariables = {id: number}

    export const useDeleteParkingSpot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteParkingSpot>>, TError,DeleteParkingSpotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteParkingSpot>>,
        TError,
        DeleteParkingSpotMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteParkingSpotMutationOptions(options), queryClient);
    }
